import React from 'react';
import { FJ181 } from '../../../services/j209Api';

interface DetailGridProps {
  details: Partial<FJ181>[];
  selectedRow: number;
  isEditing: boolean;
  setSelectedRow: (idx: number) => void;
  setDetails: React.Dispatch<React.SetStateAction<Partial<FJ181>[]>>;
  addDetailRow: () => void;
  deleteDetailRow: () => void;
}

const DetailGrid: React.FC<DetailGridProps> = React.memo(({
  details, selectedRow, isEditing, setSelectedRow, setDetails,
  addDetailRow, deleteDetailRow,
}) => {
  const updateDetail = (idx: number, key: keyof FJ181, value: FJ181[keyof FJ181]) => {
    setDetails(prev => {
      const next = [...prev];
      next[idx] = { ...next[idx], [key]: value };
      return next;
    });
  };

  return (
    <div>
      {isEditing && (
        <div style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
          <button className="btn btn-sm btn-primary" onClick={addDetailRow}>
            明細新增
          </button>
          <button className="btn btn-sm btn-danger" onClick={deleteDetailRow} disabled={details.length === 0}>
            明細刪除
          </button>
        </div>
      )}
      <div className="grid-wrapper">
        <table className="data-grid">
          <thead>
            <tr>
              <th style={{ width: 45 }}>項次</th>
              <th style={{ width: 80 }}>產品代號1</th>
              <th style={{ width: 80 }}>產品代號2</th>
              <th style={{ width: 80 }}>繳庫數量</th>
              <th style={{ width: 50 }}>單位</th>
              <th style={{ width: 60 }}>板號</th>
              <th style={{ width: 50 }}>等級</th>
              <th style={{ width: 50 }}>色號</th>
              <th style={{ width: 100 }}>中文色名</th>
              <th style={{ width: 100 }}>英文色名</th>
              <th style={{ width: 80 }}>CBNO.</th>
            </tr>
          </thead>
          <tbody>
            {details.map((d, i) => (
              <tr
                key={i}
                className={i === selectedRow ? 'selected' : ''}
                onClick={() => setSelectedRow(i)}
              >
                <td>{d.fj181_02}</td>
                <td>
                  <input
                    value={d.fj181_11 || ''}
                    onChange={e => updateDetail(i, 'fj181_11', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%' }}
                    maxLength={6}
                  />
                </td>
                <td>
                  <input
                    value={d.fj181_12 || ''}
                    onChange={e => updateDetail(i, 'fj181_12', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%' }}
                    maxLength={6}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={d.fj181_15 ?? ''}
                    onChange={e => updateDetail(i, 'fj181_15', parseFloat(e.target.value) || 0)}
                    disabled={!isEditing}
                    style={{ width: '100%', textAlign: 'right' }}
                  />
                </td>
                <td>{d.fj181_14 || ''}</td>
                <td>
                  <input
                    value={d.fj181_26 || ''}
                    onChange={e => updateDetail(i, 'fj181_26', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%' }}
                    maxLength={4}
                  />
                </td>
                <td>
                  <input
                    value={d.fj181_27 || ''}
                    onChange={e => updateDetail(i, 'fj181_27', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%' }}
                    maxLength={2}
                  />
                </td>
                <td>
                  <input
                    value={d.fj181_16 || ''}
                    onChange={e => updateDetail(i, 'fj181_16', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%' }}
                    maxLength={3}
                  />
                </td>
                <td>{d.fj181_161 || ''}</td>
                <td>{d.fj181_162 || ''}</td>
                <td>
                  <input
                    value={d.fj181_16a || ''}
                    onChange={e => updateDetail(i, 'fj181_16a', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%' }}
                    maxLength={10}
                  />
                </td>
              </tr>
            ))}
            {details.length === 0 && (
              <tr><td colSpan={11} style={{ textAlign: 'center', color: '#999' }}>無明細資料</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
});

DetailGrid.displayName = 'DetailGrid';
export default DetailGrid;
